import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'o3-core-page-not-found',
  imports: [RouterModule],
  templateUrl: './page-not-found.html',
  styleUrl: './page-not-found.css',
})
export class PageNotFound {}
